import Swiper from 'swiper';
// import 'swiper/css/swiper.css'
import Countdown from './template.countdown';

/*
 *  Class Teaser
 */
export
default class Teaser {
    constructor() {
        this.teasers = document.querySelectorAll('.teaser');
    }

    swiperSetMaxWidth() {
        const swipers = document.querySelectorAll('.swiper');

        for (let i = 0; i < swipers.length; i++) {
            const swiper = swipers[i];
            const teaser = swiper.querySelector('.teaser');
            const swiperSlide = swiper.querySelectorAll('.swiper-slide');

            if (swiper.offsetWidth > 768 && teaser.getAttribute('style')) {
                teaser.style.maxWidth = 'initial';
                continue;
            }

            const grid = swiper.closest('.grid');
            if (grid) {
                const offset = teaser.offsetLeft + swiper.offsetLeft;
                teaser.style.maxWidth = `${grid.offsetWidth - (offset * 2)}px`;
            } else {
                teaser.style.maxWidth = `${swiper.offsetWidth}px`;
            }

            this.placeButtons();
        }
    }

    requestSwiperSetMaxWidth() {
        window.requestAnimationFrame(this.swiperSetMaxWidth.bind(this));
    }

    triggerResize() {
        if (typeof (Event) === 'function') {
            // modern browsers
            window.dispatchEvent(new Event('resize'));
        } else {
            //This will be executed on old browsers and especially IE
            var resizeEvent = window.document.createEvent('UIEvents');
            resizeEvent.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(resizeEvent);
        }
    }

    getSwiperConfig(key, id, teaser) {

        const config = ( teaser.hasAttribute('data-swiper-config')) ? JSON.parse(teaser.getAttribute('data-swiper-config')) : {};

        const setup = {
            default: {
                spaceBetween: 50,
                watchOverflow: true,
                watchSlidesVisibility: true,
                updateOnWindowResize: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: `.swiper-button-next-${id}`,
                    prevEl: `.swiper-button-prev-${id}`
                },
                resizeEvent: 'resize',
                on: {
                    resize: this.requestSwiperSetMaxWidth.bind(this)
                }
            },
            swiperSecondSetup: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                breakpoints: {
                    480: {
                        slidesPerView: 2,
                        // slidesPerGroup: 2,
                        spaceBetween: 20
                    },
                }
            },
            swiperThirdSetup: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        // slidesPerGroup: 2,
                        spaceBetween: 20
                    },
                    1024: {
                        slidesPerView: 3,
                        // slidesPerGroup: 3,
                        spaceBetween: 30
                    },
                }
            },
            swiperFifthSetup: {
                spaceBetween: 20,
                slidesPerView: 1,
                slidesPerGroup: 1,
                breakpoints: {
                    480: {
                        slidesPerView: 2,
                        // slidesPerGroup: 2,
                        spaceBetween: 20
                    },
                    768: {
                        slidesPerView: 3,
                        // slidesPerGroup: 3,
                        spaceBetween: 30
                    },
                    1024: {
                        slidesPerView: 4,
                        // slidesPerGroup: 4,
                        spaceBetween: 30
                    },
                    1240: {
                        slidesPerView: 5,
                        // slidesPerGroup: 5,
                        spaceBetween: 40
                    },
                }
            },
        };

        return {
            ...setup.default,
            ...(setup[key] ? setup[key] : {}),
            ...config
        };
    }

    getSwiperButton(classNames) {
        const btn = document.createElement('div');
        for (let i = 0; i < classNames.length; i++) {
            btn.classList.add(classNames[i]);
        }
        return btn;
    }

    placeButtons() {
        const swipers = document.querySelectorAll('.swiper');

        for (let i = 0; i < swipers.length; i++) {
            const swiper = swipers[i];
            const teaser = swiper.querySelector('.teaser');
            const id = swiper.id.split('-')[1];

            const slideHeights = teaser.querySelectorAll('.swiper-height-detector');
            let offsetTop = 0;
            let slideBodyHeight = 0;
            for (let i = 0; i < slideHeights.length; i++) {
                offsetTop += slideHeights[i].offsetTop;
                slideBodyHeight += slideHeights[i].offsetHeight;
            }
            offsetTop /= slideHeights.length;
            slideBodyHeight /= slideHeights.length;
            const btnNext = swiper.querySelector(`.swiper-button-next-${id}`);
            const btnPrev = swiper.querySelector(`.swiper-button-prev-${id}`);
            btnNext.style.marginTop = `${offsetTop}px`;
            btnNext.style.height = `${slideBodyHeight}px`;
            btnPrev.style.marginTop = `${offsetTop}px`;
            btnPrev.style.height = `${slideBodyHeight}px`;
        }
    }

    addActiveClass(e) {
      e.target.classList.add('active');
    }

    removeActiveClass(e) {
      e.target.classList.remove('active');
    }

    addActiveClickButtonSupport(teaser) {
      const buttons = teaser.querySelectorAll('.teaser__button');
      for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i];
        button.addEventListener('mousedown', this.addActiveClass.bind(this));
        button.addEventListener('mouseup', this.removeActiveClass.bind(this));
      }
    }

    init() {
        for (let i = 0; i < this.teasers.length; i++) {
            const teaser = this.teasers[i];
            const slides = teaser.querySelectorAll('.swiper-slide');

            for (const slide of slides) {
              new Countdown(slide);
            }

            if (slides.length < 2) {
              teaser.classList.add('inactive');
              continue;
            }

            const teaserClasses = [
              ... ['swiper'],
              ... teaser.getAttribute('class').split(' ')
            ];
            const wrapper = document.createElement('div');
            wrapper.setAttribute('class', teaserClasses.join(' '));
            wrapper.id = `swiper-${i}`;
            teaser.parentNode.insertBefore(wrapper, teaser);
            wrapper.appendChild(teaser);
            wrapper.appendChild(this.getSwiperButton([`swiper-button-next-${i}`, 'swiper-button-next']));
            wrapper.appendChild(this.getSwiperButton([`swiper-button-prev-${i}`, 'swiper-button-prev']));

            teaser.classList.remove('teaser__hide-controls');
            teaser.classList.add('enabled');

            let swiper = null;

            if (teaser.classList.contains('teaser__default')) {
                const config = this.getSwiperConfig('swiperDefaultSetup', i, teaser);
                swiper = new Swiper(teaser, config);
            }

            if (teaser.classList.contains('teaser__second')) {
                const config = this.getSwiperConfig('swiperSecondSetup', i, teaser);
                swiper = new Swiper(teaser, config);
            }

            if (teaser.classList.contains('teaser__third')) {
                const config = this.getSwiperConfig('swiperThirdSetup', i, teaser);
                swiper = new Swiper(teaser, config);
            }

            if (teaser.classList.contains('teaser__fifth')) {
                const config = this.getSwiperConfig('swiperFifthSetup', i, teaser);
                swiper = new Swiper(teaser, config);
            }

            const teaserAnnouncement = teaser.querySelector('.teaser__announcement-ticker');
            if (teaserAnnouncement) {
                teaser.parentNode.classList.add('teaser__controls-on-hover');
                swiper.autoplay.start();
            }

            if (teaser.classList.contains('teaser__autoplay')) {
                swiper.autoplay.start();
            }

            this.addActiveClickButtonSupport(teaser);

            // Pause swiper when last slide is reached. Stop time is provided by user in Neos as milliseconds format.
            if ( swiper && swiper.autoplay.running ) {
                swiper.on('reachEnd', function () {
                    const pauseTime = parseInt(teaser.getAttribute('data-last-slide-pause-time'));
                    if ( pauseTime > 0 ) {
                        swiper.autoplay.stop();
                        setTimeout(function () {
                            swiper.autoplay.start();
                        }, pauseTime);
                    }
                });
            }

        }


        this.placeButtons();
        setTimeout(this.placeButtons.bind(this), 30);
        this.triggerResize();
        // Trigger resize a second time becaus ein NEOs sacling doesn't work properly
        // Reason unkown. Also onready state do not work properly. So have to exec by hand ...
        setTimeout(this.triggerResize.bind(this), 500);
        setTimeout(this.triggerResize.bind(this), 1000);
        setTimeout(this.triggerResize.bind(this), 2000);
    }

    runSwiper(swiper) {
        swiper.autoplay.start();
    }
}
